var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{ref:"child",attrs:{"filter":_vm.filter,"filter-for-server":_vm.filterForServer,"filter-ready":_vm.filterReady},on:{"filter-confirm":_vm.confirmFilter,"expanded":_vm.collapseNavigator}})
}
var staticRenderFns = []

export { render, staticRenderFns }